export const AV_INITIATIVE = 'wl_agency_card';
export const APP_NAME = 'agencyCard';
export const WLAC_CONTAINER_ID = `${APP_NAME}-container`;
export var Context;
(function (Context) {
    Context["ESTIMATION_FUNNEL"] = "estimation_funnel";
    Context["PRICE_MAP"] = "price_map";
})(Context || (Context = {}));
export var Brand;
(function (Brand) {
    Brand["IMN"] = "IMN";
    Brand["IWB"] = "IWB";
    Brand["IWT"] = "IWT";
    Brand["LI"] = "LI";
    Brand["MA"] = "MA";
    Brand["SL"] = "SL";
})(Brand || (Brand = {}));
export var Language;
(function (Language) {
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["FR"] = "fr";
    Language["NL"] = "nl";
})(Language || (Language = {}));
export var Country;
(function (Country) {
    Country["BE"] = "BE";
    Country["DE"] = "DE";
    Country["FR"] = "FR";
})(Country || (Country = {}));
